import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

export default function FileUpload({ color }) {
  const theme = useContext(ThemeContext);
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.54687 6C3.44231 6 2.54688 6.89543 2.54688 8V17C2.54688 18.1046 3.4423 19 4.54687 19H19.456C20.5605 19 21.456 18.1046 21.456 17V8C21.456 6.89543 20.5605 6 19.456 6H4.54687ZM12.3841 8.16475C12.172 7.94508 11.828 7.94508 11.6159 8.16475L8.1591 11.7445C7.94697 11.9642 7.94697 12.3203 8.1591 12.54C8.37122 12.7596 8.71515 12.7596 8.92728 12.54L11.4568 9.9205V16.4375C11.4568 16.7482 11.7 17 12 17C12.3 17 12.5432 16.7482 12.5432 16.4375V9.9205L15.0727 12.54C15.2849 12.7596 15.6288 12.7596 15.8409 12.54C16.053 12.3203 16.053 11.9642 15.8409 11.7445L12.3841 8.16475Z'
        fill={color ? theme.palette[color] : theme.dim['60_white']}
      />
    </svg>
  );
}
